import styled from '@emotion/styled';

export const SContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
  flex-direction: row;
  cursor: pointer;
`;

export const SInner = styled.div`
  display: flex;
`;

export const SExpandIcon = styled.button`
  padding: 16px 0;
  padding-left: 16px;
  border: none;
  cursor: pointer;
  background: transparent;
`;

export const SLabel = styled.p`
  padding: 16px;
  cursor: pointer;
  width: 200px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 0;
`;

export const SBadge = styled.div`
  height: 20px;
  background: #f0f0f0;
  border-radius: 100px;
  padding: 0 8px;
  line-height: 20px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
`;
